import styled from 'styled-components';

const SVGElement = styled.svg`
  width: 6vh;
  height: 6vh;
  padding-left : 4.5vh;
  margin-top : 7vh;
`;

export default SVGElement;